export const ACTION_CODE = {
    COPY: 1,
    PASTE: 2,
    INSERT: 3,
    DELETE: 4
}
